import { useState } from "react";

export const DashboardState = ()=>{

    const [salesData, setSalesData] = useState([])
    const [peakHours, setPeakHours] = useState([])
    const [donutChart, setDonutChart] = useState({  series: [], labels:[], });

    const [productSales, setProductSales] = useState([])
    const [generateForm, setGenerateForm] = useState({infiniteLoad:false, limit:100, offset:0})
    const [loader, setLoader] = useState({peakHours:false})
    const [branchSales, setBranchSales] = useState({totalSales: 0, totalVariance: 0, totalActualSales: 0,  numberOfDays: 0})
    const [triggerFetch, setTriggerFetch] = useState(false)
    const [days, setDays] = useState(1)
    const [totalQuantity, setTotalQuantity] = useState(0)
    
    const [form, setForm] = useState({branch_id:0, from:'', to:''})
    const [branchData, setBranchData] = useState([])
    return {
        salesData: {data: salesData, set: setSalesData},
        donutChart: {data: donutChart, set: setDonutChart},
        peakHours: {data: peakHours, set: setPeakHours},
        productSales: {data: productSales, set: setProductSales},
        form: {data: form, set: setForm},
        generateForm: {data: generateForm, set: setGenerateForm},
        loader: {data: loader, set: setLoader},
        branchSales: {data: branchSales, set: setBranchSales},
        triggerFetch: {data: triggerFetch, set: setTriggerFetch},
        days: {data: days, set: setDays},
        totalQuantity: {data: totalQuantity, set: setTotalQuantity},

        branchData:{ data: branchData, set: setBranchData}


    }

}

